import { render, staticRenderFns } from "./selfTry.vue?vue&type=template&id=33baa093&scoped=true"
import script from "./selfTry.vue?vue&type=script&lang=js"
export * from "./selfTry.vue?vue&type=script&lang=js"
import style0 from "./selfTry.vue?vue&type=style&index=0&id=33baa093&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33baa093",
  null
  
)

export default component.exports